import { ICONS } from '@thinknet-gmbh/platform-common-ui';
import { GanttPlacementConflictTypesEnum } from '@thinknet-gmbh/platform-common';

export const CONFLICTS_TO_ICONS_RELATIONS = {
  [GanttPlacementConflictTypesEnum.ERROR]: ICONS.errorCircleSolid,
  [GanttPlacementConflictTypesEnum.EMPLOYEE_WEEKEND]: ICONS.calendarX,
  [GanttPlacementConflictTypesEnum.COMPANY_HOLIDAY]: ICONS.buildingHouse,
  [GanttPlacementConflictTypesEnum.COMPANY_WEEKEND]: ICONS.homeAlt,
  [GanttPlacementConflictTypesEnum.OVERLAPPED_ENTRY]: ICONS.layer,
  [GanttPlacementConflictTypesEnum.EMPLOYEE_NOT_ENOUGH_WORKING_TIME]: ICONS.timeFive,
};
